export default "__VITE_ASSET__BG0tTUDn__"